import { createCustomEnum } from "../customEnum";

const MissingScheduleAResidualSplitProfileTypes = createCustomEnum({
	ScheduleASplitProfile: {
		value: 0,
		name: "scheduleASplitProfile",
		displayName: "Schedule A & Split Profile",
	},
	ScheduleA: {
		value: 1,
		name: "scheduleA",
		displayName: "Schedule A",
	},
	ResidualSplitProfile: {
		value: 2,
		name: "residualSplitProfile",
		displayName: "Residual Split Profile",
	},
});

export default MissingScheduleAResidualSplitProfileTypes;
